import React, { useEffect, useState } from 'react';
import { PlusCircle, Search } from 'lucide-react';

const InvoiceHeader = ({ 
  searchQuery, 
  setSearchQuery, 
  isSearchOpen, 
  setIsSearchOpen, 
  onCreateInvoice 
}) => {
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile/tablet - Updated breakpoint to match quote tracker
  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= 1024); // Changed to 1024px to include tablets
    };
    
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
    if (!isSearchOpen) {
      setTimeout(() => {
        const input = document.querySelector('.Invoice-tracking-search-input');
        if (input) input.focus();
      }, 150);
    } else {
      setSearchQuery('');
    }
  };

  const handleInputBlur = (e) => {
    // Don't close if clicking on the search icon
    if (!e.relatedTarget || !e.relatedTarget.closest('.Invoice-tracking-search-icon')) {
      if (!searchQuery.trim()) {
        setIsSearchOpen(false);
      }
    }
  };

  const handleSearchIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleSearch();
  };

  return (
    <>
      <div className="Invoice-tracking-invoice-management-header">
        <div className="Invoice-tracking-header-left">
          <h1 className="Invoice-tracking-page-title">INVOICES</h1>
        </div>
        <div className="Invoice-tracking-header-right">
          {/* Desktop: Show search toggle and create button */}
          {!isMobile && (
            <>
              <div className={`Invoice-tracking-search-input-wrapper ${isSearchOpen ? 'search-open' : ''}`}>
                <span 
                  className="Invoice-tracking-search-icon" 
                  onClick={handleSearchIconClick}
                  tabIndex={0}
                  role="button"
                  aria-label="Toggle search"
                >
                  <Search size={16} color='#000' />
                </span>
                <input
                  type="text"
                  placeholder="Search invoices..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onBlur={handleInputBlur}
                  className="Invoice-tracking-search-input"
                  aria-label="Search invoices"
                />
              </div>
            </>
          )}
          
          <button 
            className="Invoice-tracking-create-invoice-btn" 
            onClick={onCreateInvoice}
            aria-label={isMobile ? "Create invoice" : "Create Invoice"}
          >
            {isMobile ? (
              <>
                <PlusCircle size={20} />
                <span>Create Invoice</span>
              </>
            ) : (
              <>
                Create Invoice <PlusCircle size={18} className="Invoice-tracking-create-icon" />
              </>
            )}
          </button>
        </div>
      </div>

      {/* Mobile/Tablet: Show open search bar below header */}
      {isMobile && (
        <div className="Invoice-tracking-mobile-search-container">
          <div className="Invoice-tracking-mobile-search-wrapper">
            <Search size={16} color='#666' className="Invoice-tracking-mobile-search-icon" />
            <input
              type="text"
              placeholder="Search invoices..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="Invoice-tracking-mobile-search-input"
              aria-label="Search invoices"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default InvoiceHeader;